module.exports = __webpack_public_path__ + "img/eConnect_News_Posts.e4f70eca.jpg";